import { useLayoutEffect } from "react";

import { type ToolbarItem, ToolbarItems } from "components/lib/EntityHeader";

import { useEditToolbarStore } from "./store";

/**
 * The right of an area's toolbar (challenge, group, admin): its own items,
 * then the controls of the page's `EditToolbar`. Pages without it show their
 * edit controls in a toolbar of their own.
 */
export function EditToolbarItems({ items = [] }: { items?: ToolbarItem[] }) {
  useLayoutEffect(() => {
    useEditToolbarStore.setState((state) => ({ hosts: state.hosts + 1 }));
    return () =>
      useEditToolbarStore.setState((state) => ({ hosts: state.hosts - 1 }));
  }, []);
  const editItems = useEditToolbarStore((state) => state.items);

  return (
    <ToolbarItems items={[...items, ...Object.values(editItems).flat()]} />
  );
}
